import React from 'react';

import { updateEvent } from '../lib/PropagationEventHelpers';

export const PropagationInterceptor: FC = ({ children }) => {
  const onClickHandle = (e: React.MouseEvent): void => {
    updateEvent(e);
  };

  return (
    // Останавливаем всплытие события
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-noninteractive-element-interactions
    <section
      role="group"
      onClick={onClickHandle}
    >
      {children}
    </section>
  );
};
